import React, { useState } from 'react';

const services = [
  'Study Abroad Guidance',
  'Student Visa Support',
  'Work Visa Support',
  'Visitor Visa Support',
  'Country Selection Guidance',
  'Documentation Review',
  'Interview Preparation',
  'Other / Not Sure',
];

function GOContact() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: '',
  });
  const [sent, setSent] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSent(true);
  };

  return (
    <main className="gocontact">
      <section className="gocontact-hero">
        <div className="gop-container">
          <span className="gop-eyebrow">Contact Vedanskrix Global Opportunities</span>
          <h1>Talk to us about your study abroad or visa plan.</h1>
          <p>
            Share your destination, purpose, and timeline. We will help you understand the right
            next step with clearer planning.
          </p>
        </div>
      </section>

      <section className="gocontact-main">
        <div className="gop-container gocontact-main__grid">
          <div className="gocontact-info">
            <h2>Get In Touch</h2>
            <p className="gocontact-info__sub">
              Tell us your destination interest, purpose, and timeline. Our team will help you
              understand the right next step with clearer planning.
            </p>

            <div className="gocontact-cards">
              <div className="gocontact-card">
                <div className="gocontact-card__icon">Location</div>
                <div>
                  <strong>Our Office</strong>
                  <p>Vastral, Ahmedabad, Gujarat, India</p>
                </div>
              </div>

              <div className="gocontact-card">
                <div className="gocontact-card__icon">Email</div>
                <div>
                  <strong>Email Us</strong>
                  <p>
                    <a href="mailto:info@vedanskrix.com">info@vedanskrix.com</a>
                  </p>
                </div>
              </div>

              <div className="gocontact-card">
                <div className="gocontact-card__icon">WhatsApp</div>
                <div>
                  <strong>Message Us</strong>
                  <p>
                    <a href="https://wa.me/918758637022" target="_blank" rel="noreferrer">
                      +91 87586 37022
                    </a>
                  </p>
                </div>
              </div>

              <div className="gocontact-card">
                <div className="gocontact-card__icon">Hours</div>
                <div>
                  <strong>Working Hours</strong>
                  <p>Mon - Sat: 9:00 AM - 7:00 PM</p>
                </div>
              </div>
            </div>

            <div className="gocontact-map-box">
              <div className="gocontact-map-placeholder">
                <span className="gocontact-map-pin">Map</span>
                <p className="gocontact-map-label">Vedanskrix Global Opportunities</p>
                <p className="gocontact-map-addr">Vastral, Ahmedabad, Gujarat</p>
                <a
                  href="https://maps.google.com/?q=Vastral+Ahmedabad+Gujarat"
                  target="_blank"
                  rel="noreferrer"
                  className="gocontact-map-link"
                >
                  Open in Google Maps
                </a>
              </div>
            </div>
          </div>

          <div className="gocontact-form-wrap">
            {sent ? (
              <div className="gocontact-success">
                <div className="gocontact-success__icon">OK</div>
                <h3>Message Sent</h3>
                <p>Thank you. Our team will contact you within 24 hours.</p>
              </div>
            ) : (
              <form className="gocontact-form" onSubmit={handleSubmit}>
                <h3 className="gocontact-form__title">Send Us a Message</h3>

                <div className="gocontact-form__row">
                  <div className="gocontact-form__group">
                    <label htmlFor="go-name">Full Name *</label>
                    <input
                      id="go-name"
                      name="name"
                      type="text"
                      required
                      placeholder="Your full name"
                      value={form.name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="gocontact-form__group">
                    <label htmlFor="go-email">Email Address *</label>
                    <input
                      id="go-email"
                      name="email"
                      type="email"
                      required
                      placeholder="your@email.com"
                      value={form.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="gocontact-form__row">
                  <div className="gocontact-form__group">
                    <label htmlFor="go-phone">Phone Number</label>
                    <input
                      id="go-phone"
                      name="phone"
                      type="tel"
                      placeholder="+91 XXXXX XXXXX"
                      value={form.phone}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="gocontact-form__group">
                    <label htmlFor="go-service">Service Needed</label>
                    <select
                      id="go-service"
                      name="service"
                      value={form.service}
                      onChange={handleChange}
                    >
                      <option value="">Select a service</option>
                      {services.map((service) => (
                        <option key={service} value={service}>
                          {service}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="gocontact-form__group">
                  <label htmlFor="go-message">Your Message *</label>
                  <textarea
                    id="go-message"
                    name="message"
                    required
                    rows={5}
                    placeholder="Tell us about your country preference or requirement..."
                    value={form.message}
                    onChange={handleChange}
                  />
                </div>

                <button type="submit" className="gocontact-form__btn">
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </main>
  );
}

export default GOContact;
